import { useEffect, useState } from "react";
import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { copy } from "@/content";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { VideoSection } from "@/components/VideoSection";
import { Manifesto } from "@/components/Manifesto";
import { Products } from "@/components/Products";
import { Specs } from "@/components/Specs";
import { UseCases } from "@/components/UseCases";
import { Team } from "@/components/Team";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

function App() {
  const [lang, setLang] = useState(() => localStorage.getItem("sqb-lang") || "en");

  useEffect(() => {
    localStorage.setItem("sqb-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = copy[lang];

  return (
    <ReactLenis root options={{ lerp: 0.09, wheelMultiplier: 1.05 }}>
      <div className="App grain bg-[#020617] text-slate-50">
        <Nav t={t.nav} lang={lang} setLang={setLang} />
        <main>
          <Hero t={t.hero} />
          <Marquee items={t.marquee} />
          <VideoSection t={t.videoSection} />
          <Manifesto t={t.manifesto} />
          <Products t={t.products} />
          <Specs t={t.specs} />
          <UseCases t={t.useCases} />
          <Team t={t.team} />
          <Contact t={t.contact} />
        </main>
        <Footer t={t.footer} />
        <Toaster theme="dark" position="bottom-right" />
      </div>
    </ReactLenis>
  );
}

export default App;
